import { TASK_TYPES, TASK_STATUSES, TASK_PRIORITIES } from '@/model/task/taskTypeMeta'

export default function (vm) {
  return [
    {
      key: 'assigneeUserId',
      label: 'assignee',
      type: 'user',
      props: { clearable: true, multiple: false },
    },
    {
      key: 'statuses',
      label: 'status',
      type: 'select',
      props: {
        options: TASK_STATUSES.map(s => ({ value: s, label: vm.$t('taskStatuses.' + s) })),
        reduce: option => option.value,
        multiple: true,
        clearable: true,
      },
    },
    {
      key: 'types',
      label: 'type',
      type: 'select',
      props: {
        options: TASK_TYPES.map(t => ({ value: t, label: vm.$t('taskTypes.' + t) })),
        reduce: option => option.value,
        multiple: true,
        clearable: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'priorities',
      label: 'priority',
      type: 'select',
      props: {
        options: TASK_PRIORITIES.map(p => ({ value: p, label: vm.$t('taskPriorities.' + p) })),
        reduce: option => option.value,
        multiple: true,
        clearable: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    { key: 'creationTimeStart', label: 'from', type: 'date' },
    { key: 'creationTimeEnd', label: 'to', type: 'date' },
  ]
}
